var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.active,
          expression: "active",
        },
      ],
      staticClass: "modal",
      attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" },
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.hide.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("i", {
              staticClass:
                "fas fa-times-circle float-right d-inline-block mt-2 mr-2 text-right",
              on: { click: _vm.hide },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body pt-0" },
              [_vm._t("content")],
              2
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }